import { render, staticRenderFns } from "./EditEDSStandard.vue?vue&type=template&id=206ee8ec&"
import script from "./EditEDSStandard.vue?vue&type=script&lang=js&"
export * from "./EditEDSStandard.vue?vue&type=script&lang=js&"
import style0 from "./EditEDSStandard.vue?vue&type=style&index=0&id=206ee8ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports